import React from 'react'
import { FP_WATERMARK_URL, INITIALS_COLOR_BY_ALIAS, getInitialsFontScale, getTypeBubbleSize } from '../helpers/groupInitials'

export const typeBubbleWrapStyle = (typeAlias, size) => {
  const bubbleSize = size || getTypeBubbleSize(typeAlias)
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: bubbleSize,
    height: bubbleSize,
    lineHeight: 0,
  }
}

export const FpGroupMark = ({ typeAlias }) => {
  const isUndefined = String(typeAlias) === 'undefined'
  if (isUndefined) {
    return (
      <svg
        aria-hidden="true"
        viewBox="0 0 9 6"
        style={{
          position: 'absolute',
          top: '25%',
          left: '25%',
          width: '50%',
          height: '50%',
          pointerEvents: 'none',
          overflow: 'visible',
        }}
      >
        <g opacity="0.5">
          <path fillRule="evenodd" clipRule="evenodd" d="M5.22104 5.88832C4.59765 5.86654 4.47944 4.32967 4.49004 2.8889C4.5022 1.35459 4.70784 0.711346 5.12016 0.486851C5.41892 0.323861 6.41816 0.386135 6.46654 0.389211C7.83748 0.474806 8.375 1.39124 8.375 2.23925C8.375 3.91656 7.39387 4.0593 6.55914 4.57928C5.88427 4.99957 5.84883 5.88832 5.22104 5.88832Z" fill="#00CA8D" />
          <path fillRule="evenodd" clipRule="evenodd" d="M3.92443 0.990553C3.91848 0.520548 3.58247 0.440847 3.20119 0.407019C2.85302 0.375498 1.7917 0.355252 1.30281 0.430084C0.620962 0.535412 0.521115 1.68172 0.502232 2.93823C0.481539 4.34594 0.596129 5.84821 1.20943 5.88717C1.21332 5.88717 1.2172 5.88794 1.22082 5.88794C1.43318 5.89537 1.58011 5.80234 1.7022 5.6619C1.8812 5.45611 2.00484 5.14731 2.20505 4.90103C2.57107 4.45178 2.82121 4.33108 3.21024 4.0033C3.80311 3.50383 3.50435 2.88723 3.51729 2.4162C3.52711 2.07151 3.6386 1.84471 3.68775 1.7463C3.85847 1.4029 3.92676 1.18506 3.92443 0.990553Z" fill="#00CA8D" />
        </g>
      </svg>
    )
  }
  return (
    <img
      alt=""
      src={FP_WATERMARK_URL}
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        objectFit: 'contain',
      }}
    />
  )
}

const GroupInitialsMark = ({ typeAlias, initials, size }) => {
  if (!initials) {
    return null
  }
  const bubbleSize = size || getTypeBubbleSize(typeAlias)
  const fontSize = (bubbleSize / 2) * 0.85 * getInitialsFontScale(typeAlias)
  return (
    <span
      aria-hidden="true"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        fontSize: `${fontSize}px`,
        fontWeight: 700,
        letterSpacing: '-0.05em',
        color: INITIALS_COLOR_BY_ALIAS[typeAlias] || '#A1E5CD',
        lineHeight: 1,
        userSelect: 'none',
      }}
    >
      {initials}
    </span>
  )
}

export default GroupInitialsMark
